import axios from 'axios';
import { IMPROVE_CONFIG } from '@/config.js';

// Public purchase flow ("Buy Now"). No account exists until payment is
// verified server-side; these endpoints only track the purchase itself.
export default {
  // Starts a purchase and returns { uuid, status: "started" }.
  start: function(details) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/public/purchase/start', {
      plan: details.plan,
      company_name: details.company_name,
      registered_address: details.registered_address,
      company_number: details.company_number,
      contact_name: details.contact_name,
      contact_email: details.contact_email,
      first_name: details.first_name,
      last_name: details.last_name,
      phone: details.phone,
      refid: details.refid,
    });
  },
  // Returns { html, sha256_unsigned }. The html is a complete standalone
  // document of the Master Service Agreement.
  contract: function(uuid) {
    return axios.get(IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/contract');
  },
  // Signs the agreement. 409 means already signed; 410 means expired.
  sign: function(uuid, signerName) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/sign', {
      signer_name: signerName,
      agree: true,
    });
  },
  // Returns { checkout_url } to redirect to. 503 means payments not enabled yet.
  checkout: function(uuid) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/checkout', {});
  },
  // Pay by invoice instead: Stripe issues the first invoice (30 day terms)
  // and the account is created when it is paid. Returns { status:
  // "invoice_sent", invoice_url, invoice_number, amount_due_pence, due_at }.
  // Idempotent: a second call returns the same invoice.
  invoice: function(uuid) {
    return axios.post(IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/invoice', {});
  },
  // Returns { status, has_company }. Statuses: started, contract_signed,
  // payment_pending (a Stripe checkout session exists), provisioned, expired.
  status: function(uuid) {
    return axios.get(IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/status');
  },
  // Returns the sellable catalogue sourced from Stripe:
  // { plans: [{ slug, name, amount_pence, currency, interval, users_label,
  //   banding_label }, ...] sorted for display,
  //   launch_fee: { name, amount_pence } | null }.
  // 503 means the catalogue is unavailable; callers keep their display fallback.
  catalogue: function() {
    return axios.get(IMPROVE_CONFIG.API_URL + '/public/purchase/catalogue');
  },

  // Direct browser URL for the signed contract pdf (served as an attachment;
  // 409 before signing). Used as a plain <a href>, not an XHR.
  contractPdfUrl: function(uuid) {
    return IMPROVE_CONFIG.API_URL + '/public/purchase/' + uuid + '/contract.pdf';
  },

  // Storage access can throw (browsers with all site data blocked). The buy
  // flow must degrade to in-page state, never crash a lifecycle hook.
  storageGet: function(key) {
    try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
  },
  storageSet: function(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (e) { /* noop */ }
  },
  storageRemove: function(key) {
    try { window.sessionStorage.removeItem(key); } catch (e) { /* noop */ }
  },
};
